import type { ThemeColors } from '../../../../tokens/colors/types';
import type { BaseDeprecatedColors } from '../../../types';

export default (baseColors: ThemeColors): BaseDeprecatedColors => ({
  rating: baseColors.secondary['50'],
  trainProductColor: baseColors.purple['50'],
  flightProductColor: baseColors.blue['50'],
  promotional: {
    primary: {
      default: baseColors.primary['90'],
      dark: '#000D29',
    },
    secondary: {
      default: baseColors.secondary['50'],
      dark: baseColors.secondary['90'],
    },
  },
});
